
import Layout from "@/components/layout/Layout";
import ToolkitCard from "@/components/toolkit/ToolkitCard";
import { FileText, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import LoginRequiredDialog from "@/components/courses/LoginRequiredDialog";
import { Button } from "@/components/ui/button";

const FreelanceToolkit = () => {
  const { user } = useAuth();
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const [redirectPath, setRedirectPath] = useState("/freelance-toolkit/proposal-generator");

  const handleToolClick = (e: React.MouseEvent, path: string) => {
    if (!user) {
      e.preventDefault();
      setRedirectPath(path);
      setLoginDialogOpen(true);
    }
  };

  return (
    <Layout 
      title="Freelance Toolkit | Freelance With Andy"
      description="Tools to help freelancers succeed - proposal generator, profile generator, freelance success"
      keywords="freelance tools, proposal generator, profile generator, freelance success, andy nady"
      path="/freelance-toolkit"
    >
      <div className="container py-12 max-w-6xl">
        <div className="space-y-6">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold tracking-tight">Freelance Toolkit</h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Essential tools to help you win more clients and manage your freelance business more effectively.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8 px-4 md:px-0">
            <div className="md:col-span-1">
              <ToolkitCard
                title="Upwork Proposal Generator"
                description="Create winning Upwork proposals in seconds with our AI-powered proposal generator."
                icon={FileText} // Kept for backward compatibility
                linkTo={user ? "/freelance-toolkit/proposal-generator" : "#"}
                buttonText="Generate Proposal"
                imageSrc="/lovable-uploads/3246f7b7-56b0-4868-b718-522e22deb0c7.png"
                onClick={user ? undefined : (e) => handleToolClick(e, "/freelance-toolkit/proposal-generator")}
              />
            </div>
            
            <div className="md:col-span-1">
              <ToolkitCard
                title="Profile Overview Generator"
                description="Create a compelling professional profile for your freelance platforms with AI assistance."
                icon={User} // Kept for backward compatibility
                linkTo={user ? "/freelance-toolkit/profile-generator" : "#"}
                buttonText="Generate Profile Overview"
                imageSrc="/lovable-uploads/16ea837e-74c3-4eef-b1f8-51b632548d6a.png"
                onClick={user ? undefined : (e) => handleToolClick(e, "/freelance-toolkit/profile-generator")}
              />
            </div>
          </div>
        </div>
      </div>

      <LoginRequiredDialog 
        isOpen={loginDialogOpen}
        onClose={() => setLoginDialogOpen(false)}
        redirectUrl={redirectPath}
        message="Please log in to use the freelance toolkit tools."
      />
    </Layout>
  );
};

export default FreelanceToolkit;
